import {useSalesMarketingApi} from "./useSalesMarketingApi";
import qs from "qs";

export const useSubscriptionActions = () => {
    const {GET, POST, PUT} = useSalesMarketingApi();

    async function getSubscriptions(filters: any){
        let params = {
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            name: filters.name ? filters.name : undefined,
            category: filters.category ? filters.category : undefined,
            status: filters.status ? filters.status : undefined,
            id: filters.id ? filters.id : undefined,
            sku: filters.sku ? filters.sku : undefined,
            priority : filters.priority ? parseInt(filters.priority) : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined,
            createdDateFrom: filters.createdDateFrom ? filters.createdDateFrom : undefined,
            createdDateTo: filters.createdDateTo ? filters.createdDateTo : undefined,
            lastModifiedDateFrom: filters.lastModifiedDateFrom ? filters.lastModifiedDateFrom : undefined,
            lastModifiedDateTo: filters.lastModifiedDateTo ? filters.lastModifiedDateTo : undefined
        };
        let data = await GET("sm/subscription-plan/", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.result?.totalElements,
            content: data?.result?.content
        };
    }

    async function getSubscriptionById(id: any){
        let data = await GET("sm/subscription-plan/" + id, true);
        return data?.result;
    }

    async function createSubscription(payload: any) {
        return await POST("sm/subscription-plan/", payload, true)
    }

    async function updateSubscription(payload: any) {
        return await PUT("sm/subscription-plan/", payload, true)
    }

    async function getCategoriesBySegmentCode(tenantId?: string) {
        let params = {
            segmentCode: "SUB",//always SUB for subscriptions
            tenantId: tenantId
        }
        let data = await GET("sm/lookup/category-code", false, {params: params});
        return data?.result ? data.result["category-code"] : [];
    }

    async function getProductCodes(category ?:string, code? : string,controlSetFalseLoading?:boolean ){
        let params ={segmentCode: "SUB", categoryCode : category, productCode: code};
        return await GET("sm/product-code", false,{params: params},controlSetFalseLoading);
    }

    return {
        getSubscriptions,
        getSubscriptionById,
        createSubscription,
        updateSubscription,
        getCategoriesBySegmentCode,
        getProductCodes,
    };
}